import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Trusted Clients / Completed Projects logo grid.
// Renders a branded placeholder for clients without a logo URL yet — staff replace via admin.
export default function ClientsStrip() {
  const [clients, setClients] = useState([]);
  useEffect(() => { api.get("/clients").then(r => setClients(r.data)).catch(() => {}); }, []);
  if (!clients.length) return null;
  return (
    <section data-testid="clients-strip" className="section-pad bg-white border-t border-black/5">
      <div className="container-x px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
          <div>
            <div className="overline text-pipeco-green">Trusted Worldwide</div>
            <h2 className="headline text-3xl md:text-5xl mt-3 text-slate-900">10,000+ Projects Successfully Delivered</h2>
            <p className="text-slate-600 mt-4 max-w-lg text-sm md:text-base">Contractors, consultants, developers, industrial groups and government utilities trust PIPECO for engineered water storage across 22 countries.</p>
          </div>
          <div className="font-mono text-[10px] tracking-widest uppercase text-slate-500 md:text-right">
            <div>Featured Clients & Partners</div>
            <div className="text-pipeco-green font-bold mt-1">Logos coming soon</div>
          </div>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-px bg-black/5 border border-black/5">
          {clients.map((cl) => (
            <div
              key={cl.id}
              data-testid={`client-${cl.id}`}
              className="aspect-4-5 sm:aspect-1-1 bg-white grid place-items-center px-4 py-5 hover:bg-pipeco-neutral transition-colors group"
              style={{ aspectRatio: "5 / 3" }}
            >
              {cl.logo ? (
                <img src={cl.logo} alt={cl.name} className="max-h-12 max-w-full object-contain filter grayscale group-hover:grayscale-0 transition-all opacity-70 group-hover:opacity-100"/>
              ) : (
                <div className="text-center">
                  <div className="font-mono text-[8px] tracking-[0.25em] uppercase text-pipeco-green/70">Client Logo</div>
                  <div className="font-display text-sm text-slate-400 uppercase font-bold mt-1">{cl.name?.replace("Client Placeholder ", "#") || "TBA"}</div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="mt-8 text-xs text-slate-500 text-center md:text-left">Are you a PIPECO client? Reach out to feature your logo here.</div>
      </div>
    </section>
  );
}
